import { Injectable } from '@angular/core';
import { PlansRepository } from '../../../../core/repositories';
import {
  GetPlansRequest,
  Plan,
} from '../../../../core/domain';
import { filter, from, map, Observable, of, reduce } from 'rxjs';
import { PlanMockEntity } from './entities/plan-mock-entity';
import { PlanMockRepositoryMapper } from './entities/plan-mock-repository-mapper';
import { PlanRequest } from 'planning-portal-library/src/lib/core/domain/requests/plans/plan.request';
import { ClonePlanRequest } from 'planning-portal-library/src/lib/core/domain/requests/plans/clone-plan.request';
import { Duration } from 'luxon';
import { Product } from 'planning-portal-library/src/lib/core/domain/models/product';
import { PostalCode } from 'planning-portal-library/src/lib/core/domain/models/postal-code';

@Injectable({ providedIn: 'root' })
export class PlanMockRepository {
  private readonly planMapper = new PlanMockRepositoryMapper();

  plans: PlanMockEntity[] = [
    {
      id: '25',
      name: 'string',
      description: 'string',
      distance:0,
      duration: Duration.fromISO('00:00:00'),
      jobsCount: 0,
      locationsCount: 0,
      planTypeId: 1,
      units: 'Meters',
      createdAt: '00:00:00',
    },
    {
      id: '26',
      name: 'string',
      description: 'string',
      distance: 0,
      duration: Duration.fromISO('00:00:00'),
      jobsCount: 0,
      locationsCount: 0,
      planTypeId: 2,
      units: 'Meters',
      createdAt: '00:00:00',
    },
    {
      id: '27',
      name: 'string',
      description: 'string',
      distance: 0,
      duration: Duration.fromISO('00:00:00'),
      jobsCount: 0,
      locationsCount: 0,
      planTypeId: 3,
      units: 'Meters',
      createdAt: '00:00:00',
    },
  ];

  constructor() {
    //super();
  }


  getPlans(request: GetPlansRequest): Observable<Plan[]> {
    return from(this.plans)
      .pipe(map(this.planMapper.mapFrom))
      .pipe(reduce((items: Plan[], item: Plan) => [...items, item], []));
  }

  addPlan(request: PlanRequest): Observable<Plan> {
    const newId = this.genrateNewId(this.plans);
    const plan: PlanMockEntity = {
      id: newId,
      name: request.name,
      description: request.description,
      createdAt: '00:00:00',
    };
    this.plans.push(plan);
    return from(of(plan)).pipe(map(this.planMapper.mapFrom));
  }

  editPlan(request: PlanRequest): Observable<Plan> {
    const index = this.plans.findIndex((x) => x.id === request.id);
    this.plans[index].name = request.name;
    this.plans[index].description = request.description;
    this.plans[index].createdAt = '00:00:00'
    return from(this.plans.filter((x) => x.id === request.id));
  }

  deletePlan(request: string): Observable<boolean> {
    const index = this.plans.findIndex((x) => x.id === request);
    delete this.plans[index];
    return of(true);
  }

  genrateNewId(planList: Plan[]) {
    return this.plans.at(-1)!.id + 1;
  }

  clonePlan(request: ClonePlanRequest): Observable<Plan> {
    throw new Error('Method not implemented.');
  }


  getProducts(): Observable<Product[]> {
    throw new Error('Method not implemented.');
  }

  getPostalCodes(): Observable<PostalCode[]> {
    throw new Error('Method not implemented.');
  }
}
